import { Footer } from './Footer';

export function NonCatalogueContent() {
  return (
    <>
      <Footer.Block>
        <Footer.Header>Over Sunweb</Footer.Header>
        <Footer.List>
          <Footer.ListItem href="/over-sunweb">Over Sunweb</Footer.ListItem>
          <Footer.ListItem href="/mijn-sunweb">Mijn Sunweb</Footer.ListItem>
          <Footer.ListItem href="/blog">Blog</Footer.ListItem>
          <Footer.ListItem href="/vakantie/last-minutes">Last Minute</Footer.ListItem>
          <Footer.ListItem href="/all-inclusive">All inclusive</Footer.ListItem>
          <Footer.ListItem href="/pers-en-media">Pers & media</Footer.ListItem>
          <Footer.ListItem href="/groepen">Groepen</Footer.ListItem>
          <Footer.ListItem href="https://jobs.sunwebgroup.com/">Vacantures</Footer.ListItem>
          <Footer.ListItem href="/stichting-reis-met-je-hart">Stichting Reis met je Hart</Footer.ListItem>
          <Footer.ListItem href="/cookies">Cookies</Footer.ListItem>
          <Footer.ListItem href="/privacy">Privacy</Footer.ListItem>
          <Footer.ListItem href="/disclaimer">Disclaimer</Footer.ListItem>
        </Footer.List>
      </Footer.Block>
      <Footer.Block>
        <Footer.Header>Zonvakanties</Footer.Header>
        <Footer.List>
          <Footer.ListItem href="/vakantie/griekenland">Zonvakanties Griekenland</Footer.ListItem>
          <Footer.ListItem href="/vakantie/spanje">Zonvakanties Spanje</Footer.ListItem>
          <Footer.ListItem href="/vakantie/turkije">Zonvakanties Turkije</Footer.ListItem>
          <Footer.ListItem href="/vakantie/bestemmingen">Bekijk alle vakanties</Footer.ListItem>
        </Footer.List>
        <br />
        <br />
        <Footer.Header>Wintersport</Footer.Header>
        <Footer.List>
          <Footer.ListItem href="/wintersport/zwitserland">Wintersport Zwitserland</Footer.ListItem>
          <Footer.ListItem href="/wintersport/frankrijk">Wintersport Frankrijk</Footer.ListItem>
          <Footer.ListItem href="/wintersport/oostenrijk">Wintersport Oostenrijk</Footer.ListItem>
          <Footer.ListItem href="/wintersport/bestemmingen">Bekijk alle vakanties</Footer.ListItem>
        </Footer.List>
        <br />
        <br />
        <Footer.List>
          <Footer.Header>Cruisevakanties</Footer.Header>
          <Footer.ListItem href="/cruises/rederijen/msc-cruises">MSC Cruises</Footer.ListItem>
          <Footer.ListItem href="/cruises/rederijen/costa-cruises">Costa Cruises</Footer.ListItem>
          <Footer.ListItem href="/cruises/rederijen">Bekijk alle rederijen</Footer.ListItem>
        </Footer.List>
      </Footer.Block>
      <Footer.Block>
        <Footer.Header>Nieuwsbrief</Footer.Header>
        <Footer.List>
          <Footer.ListItem href="/vakantie/nieuwsbrief">Blijf op de hoogte van onze zonvakanties!</Footer.ListItem>
          <Footer.ListItem href="/wintersport/nieuwsbrief">
            Blijf op de hoogte van onze wintersportvakanties!
          </Footer.ListItem>
        </Footer.List>
        <br />
        <br />
        <Footer.Header>Vragen & contact</Footer.Header>
        <Footer.List>
          <Footer.ListItem href="https://service.sunweb.com/nl/support/home">
            Vind hier onze FAQ en onze contactgegevens
          </Footer.ListItem>
          <Footer.ListItem href="/cookies/cookieverklaring">Wijzig cookie instellingen</Footer.ListItem>
          <Footer.ListItem href="/vakantie/marketing-voorkeuren">Wijzig marketingvoorkeuren</Footer.ListItem>
        </Footer.List>
      </Footer.Block>
    </>
  );
}
